import { IPatient, constants } from '../../../..';

export type Defaults = {
    createdAt: Date;
    updatedAt: Date | null;
    createdById: string;
    updatedById: string | null;
    isDeleted: boolean;
};

export const getDefaults = (job: Partial<IPatient>): Defaults => {
    const { createDateTime } = job;

    return {
        createdAt: createDateTime ? new Date(createDateTime) : new Date(),
        updatedAt: null,
        createdById: constants.NOT_CAPTURED,
        updatedById: null,
        isDeleted: false,
    };
};
